import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, firstValueFrom, map, Observable, of, tap } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { IPrintSetting } from './iprint-setting';

@Injectable({
    providedIn: 'root'
})
export class PrintSettingService {

    private _printSetting: BehaviorSubject<IPrintSetting | null> = new BehaviorSubject<IPrintSetting | null>(null);

    constructor(private _httpClient: HttpClient) { }

    createPrintSetting(settings: IPrintSetting): Observable<BaseRespone<IPrintSetting>> {
        return this._httpClient.post<BaseRespone<IPrintSetting>>(`${environment.baseURl}/HospitalReportSetting`, settings)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((setting) => {
                    // Return the new setting
                    return setting;
                })
            )
    }


    updatePrintSetting(settings: IPrintSetting): Observable<BaseRespone<IPrintSetting>> {
        return this._httpClient.put<BaseRespone<IPrintSetting>>(`${environment.baseURl}/HospitalReportSetting`, settings);
    }

    getPrintSettingByHospitalId(id: Number) {
        return this._httpClient.get<BaseRespone<IPrintSetting>>(`${environment.baseURl}/HospitalReportSetting/hospital/${id}`).pipe(
            tap((response) => {
                this._printSetting.next(response.result);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    getPrintSettingPromise(id: number): Promise<IPrintSetting | null> {
        return firstValueFrom(this.getPrintSettingByHospitalId(id))
            .then(res => {
                if (res.isSuccess) {
                    return res.result;
                } else {
                    return null;
                }
            })
    }

}
